import { useContext } from "react";

import { AddQuoteActions, AddQuoteContextDispatch } from "components/Quotes/AddQuote/AddQuoteContext";

export function useAddQuoteActions(): AddQuoteActions {
    return useContext(AddQuoteContextDispatch)!;
};

export default useAddQuoteActions;
